import { createTheme as createTheme$1 } from '@material-ui/core/styles';
import { createBaseThemeOptions } from '../base/createBaseThemeOptions.esm.js';
import '../base/pageTheme.esm.js';
import { defaultComponentThemes } from '../v5/defaultComponentThemes.esm.js';
import { transformV5ComponentThemesToV4 } from '../unified/overrides.esm.js';

function createThemeOptions(options) {
  return {
    props: {
      MuiGrid: defaultComponentThemes?.MuiGrid?.defaultProps,
      MuiSwitch: defaultComponentThemes?.MuiSwitch?.defaultProps
    },
    ...createBaseThemeOptions(options)
  };
}
function createThemeOverrides(theme) {
  return transformV5ComponentThemesToV4(
    // Safe but we have to make sure we don't use mui5 specific stuff in the default component themes
    theme,
    defaultComponentThemes
  ).overrides;
}
function createTheme(options) {
  const themeOptions = createThemeOptions(options);
  const baseTheme = createTheme$1(themeOptions);
  const overrides = createThemeOverrides(baseTheme);
  const theme = { ...baseTheme, overrides };
  return theme;
}

export { createTheme, createThemeOptions, createThemeOverrides };
//# sourceMappingURL=baseTheme.esm.js.map
